export default __webpack_public_path__ + "static/media/bsg.7fec43cd.svg";